<template>
  <form class="space-y-3" @submit.prevent="handleLogin">
    <h1
      class="text-2xl font-extralight text-gray-200 flex justify-center text-center font-mind-force"
    >
      Acesso seguro
    </h1>

    <div class="space-y-8">
      <!-- Usuário / Email -->
      <div>
        <input
          v-model.trim="form.email"
          type="email"
          placeholder="Usuário"
          class="w-full bg-transparent border-b border-gray-600 focus:border-red-500 focus:outline-none py-2 text-gray-200 placeholder-gray-500 transition-all duration-300"
        />
      </div>

      <!-- Senha -->
      <div>
        <input
          v-model="form.password"
          type="password"
          placeholder="Senha"
          class="w-full bg-transparent border-b border-gray-600 focus:border-red-500 focus:outline-none py-2 text-gray-200 placeholder-gray-500 transition-all duration-300"
        />
      </div>

      <!-- Erro -->
      <p v-if="errorMessage" class="text-sm text-red-400 text-center">
        {{ errorMessage }}
      </p>

      <!-- Login Button -->
      <button
        type="submit"
        :disabled="loading"
        class="w-full bg-red-600 hover:bg-red-700 transition-all py-3 rounded-lg text-white font-medium shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {{ loading ? "Entrando..." : "Login" }}
      </button>
    </div>
  </form>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { getAdminMe, loginAdmin } from "@/services/auth/adminAuthService";

const router = useRouter();

const form = reactive({
  email: "",
  password: "",
});

const loading = ref(false);
const errorMessage = ref("");

async function handleLogin() {
  errorMessage.value = "";

  if (!form.email || !form.password) {
    errorMessage.value = "Preencha usuário e senha.";
    return;
  }

  loading.value = true;

  try {
    const { data } = await loginAdmin({
      email: form.email,
      password: form.password,
    });

    if (data.success) {
      await getAdminMe(); // força validação de sessão
      router.push({ name: "adm-home" });
    }
  } catch (error) {
    console.log(error);
    errorMessage.value =
      error?.response?.data?.message || "Não foi possível realizar o login.";
  } finally {
    loading.value = false;
  }
}
</script>
